// extracted by mini-css-extract-plugin
export default {"container":"PostSeriesMeta-module__container---82qI","hoverable":"PostSeriesMeta-module__hoverable--ckleC","animatedBackground":"PostSeriesMeta-module__animatedBackground--iqJmX"};